import {
  isServerResponseError,
  hasError,
} from '../common'
import {
  pathOr,
  prop,
} from 'ramda'
import {
  getCustomerConsumptionUsage
} from '../../services/apis'

const getConsumptionData = async (id, from, to) => {
  const result = await getCustomerConsumptionUsage(id)({
    from,
    to
  })
  return isServerResponseError(result) || hasError(result)
    ? []
    : pathOr([], ['data', 'data'], result)
}

export default getConsumptionData
